import React, { ReactElement } from 'react';
import { ComponentType, Props } from './';
import './ProductSpecification.scss';

const ProductSpecification: ComponentType = ({ specification }: Props): ReactElement => {
  const attributeGroups = specification.map((group, key) => {
    const attributes = group.attributes.map((attribute, key) => {
      const values = attribute.values.map((value, key) => (
        <li key={key}>{value}</li>
      ));

      return (
        <tr key={key}>
          <td className="cds-Table-Cell--SpecsAttribute">{attribute.name}</td>
          <td>
            <ul>{values}</ul>
          </td>
        </tr>
      );
    });

    return (
      <React.Fragment key={key}>
        <tr>
          <th colSpan={2}>{group.name}</th>
        </tr>
        {attributes}
      </React.Fragment>
    );
  });

  return (
    <div className="ProductSpecification">
      <table className="cds-Table cds-Table--Specs">
        <tbody>{attributeGroups}</tbody>
      </table>
    </div>
  );
};

export { ProductSpecification };
